export const headerDataLibrary = {
    title: 'GED',
    submodules: [
        createData(0, "Rubrique", "/rubrique"),
        // createData(1, "Rubrique Secondaire", "/secondaire"),
       createData(1, "Document", "/document"),
       createData(2, "Emplacement", "/emplacement"),
        

        // createData(3, "Annuaire", "/annuaire"),
        // createData(4, "Information sur la Famille", "/information_famille"),
    ],
}

function createData(id, moduleName, ref) {
    return { id, moduleName, ref };
}